import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { renderBusinessRegisterForm } from './render-business-register';

export function renderEnterprise(target: HTMLElement): void {
  const panelInner = createEl('div', { className: 'sv-enterprise-panel' }, [
    createEl('h2', { className: 'sv-enterprise-panel__title', id: 'enterprise-title' }, [
      SITE.enterpriseTitle,
    ]),
    createEl('p', { className: 'sv-enterprise-panel__subtitle' }, [SITE.enterpriseSubtitle]),
  ]);

  renderBusinessRegisterForm(panelInner);

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-enterprise-section',
      id: 'soluciones-empresas',
      'aria-labelledby': 'enterprise-title',
    },
    [createEl('div', { className: 'sv-inner sv-inner--enterprise' }, [panelInner])]
  );

  target.appendChild(section);
}
